import { render } from "./FootView.vue?vue&type=template&id=52a5210d&scoped=true"
import script from "./FootView.vue?vue&type=script&lang=js"
export * from "./FootView.vue?vue&type=script&lang=js"

import "./FootView.vue?vue&type=style&index=0&id=52a5210d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a5210d"]])

export default __exports__